import { render } from "./TableIndex.vue?vue&type=template&id=66bc75eb"
const script = {}

import "./TableIndex.vue?vue&type=style&index=0&id=66bc75eb&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__